import ajax from "./ajax";

export function bookmarkCandidate(data) {
  return ajax(`/CandidateBookmark/AddBookmark`, { method: "POST", data });
}

export function getBookmarkedCandidates(params = '') {
  return ajax(`/CandidateBookmark/GetMyBookmarks?sort=-id${params}`);
}

export function removeBookmarkCandidate(id) {
  return ajax(`/CandidateBookmark/RemoveBookmark/${id}`, { method: "DELETE" });
}

export function updateApplicationStatus(data) {
  return ajax(`/candidatebookmarks/status`, { method: "PUT", data });
}
